import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { DownloadIcon } from '@change/ds-icons';

import { downloadButtonStyle, shareableAssetStyles, shareableImageStyle } from './styles';

export type ShareVisual = {
	id: string;
	variantName: string;
	image: { alt: string; srcSet: string; src: string; fullsizeSrc: string };
};

export const ShareableAsset: React.FC<{
	asset: ShareVisual;
	type: 'story' | 'post' | 'legacy';
	isLast?: boolean;
	submit: (event: React.FormEvent<HTMLFormElement>) => void;
}> = ({ asset, type, isLast = false, submit }) => {
	return (
		<form onSubmit={submit} data-qa="share-visual-modal-form" className={shareableAssetStyles({ isLast })}>
			<input type="hidden" name="share-visuals" value={asset.variantName} />
			<div className="relative h-full">
				<img
					src={asset.image.src}
					srcSet={asset.image.srcSet}
					alt={asset.image.alt}
					className={shareableImageStyle({ type })}
				/>
				<button
					type="submit"
					data-qa="download-image"
					aria-label="Download image"
					title="Download"
					className={downloadButtonStyle({ type })}
				>
					<div className="grid h-9 w-9 place-items-center rounded-lg bg-white text-black backdrop-blur-sm">
						<DownloadIcon />
					</div>
				</button>
			</div>
			<div className="relative flex items-center justify-center pt-4 lg:hidden">
				<Button
					type="submit"
					data-qa="download-image"
					aria-label="Download image"
					title="Download"
					className="rounded-lg border p-2"
					leadingIcon={<DownloadIcon />}
					iconOnly
				>
					Download
				</Button>
			</div>
		</form>
	);
};
